export class Project {
	Address: string;
	BreakDuration: number;
	City: string;
	CreatedBy: number;
	CreatedDate: string;
	EnableFieldActivities: boolean;
	EndDate: string;
	FIPSStateId: number;
	Id: number;
	IsActive: boolean;
	IsArchived: boolean;
	IsCRCodeRequired: boolean;
	IsDeleted: boolean;
	LBB: boolean;
	Latitude: number;
	Longitude: number;
	LunchDuration: number;
	ModifiedBy: number;
	ModifiedDate: string;
	Name: string;
	Number: string;
	OrganizationId: number;
	RecordId: number;
	StartDate: string;
	TimeRoundTo: number;
	TimeZoneId: number;
	WorkDayEnd: string;
	WorkDayStart: string;
	WorkweekStartDay: number;
	RequireMileage: boolean;
	EnableLaborCategoryAssignment: boolean;
	constructor(obj?: Partial<Project>) {
		if (obj) {
				Object.assign(this, obj);
		}
		else {
			throw Error('Object cannot be null');
		}
	}

	get NameAndNumber(): string {
		return this.Name + ' (' + this.Number + ')';
	}
}
